var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "33pt",
    height: "33pt",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.070313 0.378906 C 7.011719 0.378906 4.523438 2.867188 4.523438 5.925781 L 4.523438 31.523438 C 4.523438 32.003906 4.792969 32.445313 5.222656 32.664063 C 5.648438 32.882813 6.164063 32.84375 6.554688 32.5625 L 16.875 25.304688 C 16.863281 25.089844 16.148438 22.035156 16.148438 21.816406 C 16.148438 15.691406 18.046875 29.363281 24.171875 29.363281 C 25.054688 29.363281 27.59375 15 28.417969 15.191406 L 28.417969 5.925781 C 28.417969 2.867188 25.929688 0.378906 22.871094 0.378906 Z M 10.070313 0.378906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 22.871094 0.277344 C 25.929688 0.277344 28.417969 2.765625 28.417969 5.824219 L 28.417969 31.421875 C 28.417969 31.902344 28.148438 32.34375 27.71875 32.5625 C 27.292969 32.78125 26.777344 32.742188 26.390625 32.460938 L 15.839844 25.234375 C 15.851563 25.019531 10.511719 22.871094 10.511719 22.652344 C 10.511719 16.523438 14.949219 27.894531 8.820313 27.894531 C 7.941406 27.894531 5.347656 14.898438 4.523438 15.089844 L 4.523438 5.824219 C 4.523438 2.765625 7.011719 0.277344 10.070313 0.277344 Z M 22.871094 0.277344 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.2c2576a78b233690e5344d0cce263d57.svg";
export { ForwardRef as ReactComponent };